import type { BatchPeekContext } from "@/components/hub/entityPeekTypes";

export interface KittingBatchPeekApi {
  batch_id: number;
  mfr_ship_by_date: string | null;
  ship_to_label: string | null;
  location_id: number | null;
  location_label: string | null;
  shipment_on_hold: boolean;
  serial_count: number;
  line_count: number;
  work_order_numbers: string[];
  finished_sku_lines: { sku: string; quantity: number }[];
}

export type KittingBatchPeekMap = Record<number, KittingBatchPeekApi>;

export function kittingBatchPeekContext(input: {
  apiPeek?: KittingBatchPeekApi;
  linkedWorkOrderNumbers?: readonly string[];
  loading?: boolean;
}): BatchPeekContext | undefined {
  const { apiPeek, linkedWorkOrderNumbers, loading } = input;
  const workOrderNumbers =
    apiPeek?.work_order_numbers != null && apiPeek.work_order_numbers.length > 0
      ? apiPeek.work_order_numbers
      : linkedWorkOrderNumbers;

  const hasWorkOrders = workOrderNumbers != null && workOrderNumbers.length > 0;
  const hasApiFields =
    apiPeek != null &&
    (apiPeek.mfr_ship_by_date != null ||
      apiPeek.ship_to_label != null ||
      (apiPeek.location_id != null && apiPeek.location_id > 0) ||
      (apiPeek.location_label != null && apiPeek.location_label.trim() !== "") ||
      apiPeek.line_count > 0 ||
      apiPeek.serial_count > 0 ||
      apiPeek.shipment_on_hold ||
      apiPeek.finished_sku_lines.length > 0);

  if (!loading && !hasApiFields && !hasWorkOrders) {
    return undefined;
  }

  return {
    mfr_ship_by_date: apiPeek?.mfr_ship_by_date ?? null,
    ship_to_label: apiPeek?.ship_to_label ?? null,
    location_id: apiPeek?.location_id ?? null,
    location_label: apiPeek?.location_label ?? null,
    shipment_on_hold: apiPeek?.shipment_on_hold ?? false,
    line_count: apiPeek?.line_count ?? null,
    serial_count: apiPeek?.serial_count ?? null,
    work_order_numbers: workOrderNumbers,
    finished_sku_lines: apiPeek?.finished_sku_lines,
    loading,
  };
}
